import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import StopRoundedIcon from '@mui/icons-material/StopRounded';

const BAR_COUNT = 22;

const formatElapsedTime = (seconds = 0) => {
  const safeSeconds = Math.max(0, Math.floor(seconds));
  return `${Math.floor(safeSeconds / 60)}:${String(safeSeconds % 60).padStart(2, '0')}`;
};

const LiveVoiceRecordingStatus = ({ audioLevel = 0, elapsedSeconds = 0, quietInput = false, onStop }) => {
  const normalizedLevel = Math.max(0.04, Math.min(1, audioLevel));

  return (
    <Box sx={{ display: 'grid', gap: 1.5, p: 2, border: '1px solid', borderColor: 'divider', borderRadius: '18px', bgcolor: 'background.paper' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box aria-hidden sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: 'error.main', animation: 'voicePulse 1.4s ease-in-out infinite', '@keyframes voicePulse': { '0%, 100%': { opacity: 1 }, '50%': { opacity: 0.35 } } }} />
          <Typography sx={{ fontWeight: 700 }}>Recording</Typography>
        </Box>
        <Typography sx={{ fontVariantNumeric: 'tabular-nums', color: 'text.secondary', fontWeight: 600 }}>{formatElapsedTime(elapsedSeconds)}</Typography>
      </Box>

      <Box aria-label="Live microphone level" role="meter" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(normalizedLevel * 100)} sx={{ height: 58, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', px: 1, borderRadius: '14px', bgcolor: 'action.hover', overflow: 'hidden' }}>
        {Array.from({ length: BAR_COUNT }, (_, index) => {
          const shape = 0.48 + (Math.sin(index * 1.7) + 1) * 0.26;
          const height = Math.max(4, Math.round(52 * normalizedLevel * shape));
          return <Box key={index} aria-hidden sx={{ width: 4, height, minHeight: 4, borderRadius: 4, bgcolor: 'primary.main', transition: 'height 90ms linear' }} />;
        })}
      </Box>

      {quietInput ? <Typography role="status" sx={{ color: 'text.secondary', fontSize: '0.88rem', textAlign: 'center' }}>We’re not hearing much—check your microphone.</Typography> : null}

      <Button variant="contained" color="error" startIcon={<StopRoundedIcon />} onClick={onStop} sx={{ minHeight: 48, textTransform: 'none', borderRadius: '16px' }}>Stop recording</Button>
    </Box>
  );
};

export default LiveVoiceRecordingStatus;
